export const isBefore = (end: number, start?: number) => {
  return start ? end < start : false;
};
